import cap from "../assets/cap.svg";
import cap1 from "../assets/cap1.svg";
import cap2 from "../assets/cap2.svg";
import sweat from "../assets/sweat.svg";
import sweat1 from "../assets/sweat1.svg";
import sweat2 from "../assets/sweat2.svg";
import hoodie2 from "../assets/Hoodie2.svg";
import tyrionhoodie1 from "../assets/tyrionhoodie1.svg";

const products = [
  {
    id: 1,
    name: "Black Tyrion Hoodie",
    price: "NGN 25,000",
    description: "This is a black hoodie with a white Tyrion logo",
    image: tyrionhoodie1,
    size: ["S"],

    category: "hoodie",
  },
  {
    id: 2,
    name: "White Tyrion Hoodie",
    price: "NGN 25,000",
    description: "This is a white hoodie with a black Tyrion logo",
    size: ["S", "M"],
    image: hoodie2,
    category: "hoodie",
  },
  {
    id: 3,
    name: "Black Tyrion Cap",
    price: "NGN 7,000",
    description: "This is a black cap with a white Tyrion logo",
    image: cap,
    size: ["N/A"],
    category: "cap",
  },
  {
    id: 4,
    name: "White Tyrion Cap",
    price: "NGN 3,000",
    description: "This is a white cap with a black Tyrion logo",
    image: cap1,
    size: ["N/A"],
    category: "cap",
  },
  {
    id: 5,
    name: "White Tyrion Cap",
    price: "NGN 5,000",
    description: "This is a white cap with a black Tyrion logo",
    image: cap2,
    size: ["N/A"],
    category: "cap",
  },
  {
    id: 6,
    name: "White Tyrion Sweatshirt",
    price: "NGN 25,000",
    description: "This is a white sweatshirt with a Tyrion logo",
    image: sweat,
    size: ["L", "M"],
    category: "sweatshirt",
  },
  {
    id: 7,
    name: "Black Tyrion Sweatshirt",
    price: "NGN 25,000",
    description: "This is a black sweatshirt with a Tyrion logo",
    image: sweat1,
    size: ["L", "M"],
    category: "sweatshirt",
  },
  {
    id: 8,
    name: "White Tyrion Sweatshirt",
    price: "NGN 25,000",
    description: "This is a white sweatshirt with a black Tyrion logo",
    size: ["L", "M"],
    image: sweat2,
    category: "sweatshirt",
  },
];

export default products;
